export const english = {
  'app.name': 'WhatTheIgnore',
  'app.tagline': 'See exactly why Git ignores a file.',
  'app.description': 'A local-only visual debugger for .gitignore rules.',
  'actions.loadFolder': 'Load folder',
  'actions.loadGitignore': 'Load .gitignore',
  'actions.pastePaths': 'Paste paths',
  'actions.loadSample': 'Load sample',
  'actions.reset': 'Reset',
  'actions.apply': 'Apply',
  'actions.applySuggestion': 'Apply suggestion',
  'actions.undo': 'Undo',
  'actions.cancel': 'Cancel',
  'actions.close': 'Close',
  'actions.copy': 'Copy',
  'actions.download': 'Download',
  'actions.retry': 'Try again',
  'actions.expandAll': 'Expand all',
  'actions.collapseAll': 'Collapse all',
  'actions.clearSearch': 'Clear search',
  'privacy.localOnly': 'Local-only',
  'privacy.noUploads': 'No uploads',
  'privacy.noAnalytics': 'No analytics',
  'privacy.folderNotice': 'Your files never leave this browser.',
  'privacy.fileContents': 'Only .gitignore files are read; other files are used by path only.',
  'input.sample': 'Sample project',
  'input.pasteMode': 'Paste mode',
  'input.rulesLabel': '.gitignore rules',
  'input.pathsLabel': 'Project paths',
  'input.pathsHint': 'Enter one repository-relative path per line.',
  'input.dropFolder': 'Drop a project folder here',
  'input.dropGitignore': 'Drop a .gitignore file here',
  'input.orChoose': 'or choose a file',
  'input.folderUnsupported':
    'Folder selection is unavailable in this browser. Paste paths instead.',
  'input.pathLimit': 'Up to {count} paths can be analyzed at once.',
  'rules.title': 'Rules',
  'rules.source': 'Source',
  'rules.line': 'Line {line}',
  'rules.matches': '{count} matches',
  'rules.noSelection': 'Select a rule to filter affected paths.',
  'rules.edit': 'Edit rules',
  'files.title': 'Files',
  'files.search': 'Search paths',
  'files.total': '{count} paths',
  'files.ignoredCount': '{count} ignored',
  'files.empty': 'No paths match the current filters.',
  'files.kindFile': 'File',
  'files.kindDirectory': 'Directory',
  'why.title': 'Why?',
  'why.finalStatus': 'Final status',
  'why.decisiveRule': 'Decisive rule',
  'why.ruleSource': 'Rule source',
  'why.timeline': 'Match timeline',
  'why.noMatch': 'No ignore rule matched this path.',
  'why.selectPath': 'Select a path to inspect every matching rule.',
  'why.blocked': 'A parent directory is ignored, so this negation cannot restore the child.',
  'why.copyCheckIgnore': 'Copy git check-ignore command',
  'why.copyRemoveCached': 'Copy git rm --cached command',
  'status.ignored': 'Ignored',
  'status.tracked': 'Tracked',
  'status.active': 'Active',
  'status.matched': 'Matched',
  'status.unmatched': 'Unmatched',
  'status.overridden': 'Overridden',
  'status.blockedNegation': 'Blocked negation',
  'status.broadRule': 'Broad rule',
  'status.comment': 'Comment',
  'status.blank': 'Blank',
  'filters.all': 'All',
  'filters.ignored': 'Ignored',
  'filters.tracked': 'Tracked',
  'filters.warnings': 'Warnings',
  'warnings.title': 'Diagnostics',
  'warnings.blockedNegation': 'This negation is blocked by an ignored parent directory.',
  'warnings.broadRule': 'This broad rule may affect more paths than intended.',
  'warnings.unmatched': 'This rule did not match the current project tree.',
  'warnings.overridden': 'Later rules override every current match from this rule.',
  'warnings.sensitiveUnignored': 'A potentially sensitive path is currently tracked.',
  'warnings.sensitiveReincluded': 'A later rule restores a potentially sensitive path.',
  'warnings.currentInputOnly': 'Unmatched means only that no current input path matched.',
  'progress.queued': 'Preparing analysis…',
  'progress.analyzing': 'Analyzing {count} paths…',
  'progress.complete': 'Analysis complete.',
  'progress.folder': 'Reading folder… {completed}/{total}',
  'errors.title': 'Something needs attention',
  'errors.workerFailed': 'The worker stopped unexpectedly. Analysis continued on the main thread.',
  'errors.analysisFailed':
    'The input was preserved. Review the rules or paths, then retry the analysis.',
  'errors.workerLargeInput':
    'The worker is unavailable, so this large input was not analyzed on the main thread. Reduce the path list or retry in a browser with Worker support.',
  'errors.invalidPath': 'Use repository-relative paths only.',
  'errors.pathTraversal': 'Paths containing .. are not accepted.',
  'errors.absolutePath': 'Absolute paths are not accepted or stored.',
  'errors.duplicatePath': 'This duplicate path was analyzed once.',
  'errors.notGitignore': 'Choose a file named .gitignore. The selected file was not read.',
  'errors.binaryGitignore': 'This .gitignore appears to be binary and was not analyzed.',
  'errors.invalidEncoding': 'This .gitignore is not valid UTF-8.',
  'errors.gitignoreTooLarge': 'This .gitignore is too large to analyze safely.',
  'errors.pathLimit': 'The folder exceeded {count} paths; remaining entries were not read.',
  'errors.readFailed': 'The browser could not read this file. Other input was preserved.',
  'errors.exportFailed': 'The report could not be exported. Your analysis is still available.',
  'errors.storageUnavailable': 'Preferences apply for this session but could not be saved.',
  'export.title': 'Export',
  'export.copyGitignore': 'Copy updated .gitignore',
  'export.downloadGitignore': 'Download updated .gitignore',
  'export.markdown': 'Export Markdown report',
  'export.json': 'Export JSON report',
  'export.includeProjectName': 'Include project folder name',
  'export.copied': 'Copied to clipboard.',
  'export.downloaded': 'Download prepared.',
  'theme.dark': 'Dark theme',
  'theme.light': 'Light theme',
  'theme.toggle': 'Switch color theme',
  'language.label': 'Language',
  'language.english': 'English',
  'language.chinese': '简体中文',
  'tabs.rules': 'Rules',
  'tabs.files': 'Files',
  'tabs.why': 'Why',
  'a11y.analysisStatus': 'Analysis status',
  'a11y.openMenu': 'Open menu',
  'a11y.closeDialog': 'Close dialog',
  'a11y.ruleSelected': 'Rule selected',
  'a11y.pathSelected': 'Path selected',
  'footer.license': 'MIT License',
  'footer.github': 'GitHub',
  'sample.name': 'Teaching sample',
  'sample.description': 'Explore negations, overridden rules, and an ignored parent directory.',
  'accessibility.skipToWorkbench': 'Skip to workbench',
  'actions.exportReport': 'Export report',
  'actions.language': 'Choose language',
  'actions.openGithub': 'Open the GitHub repository',
  'actions.useDarkTheme': 'Use dark theme',
  'actions.useLightTheme': 'Use light theme',
  'actions.analyzeInputs': 'Analyze inputs',
  'actions.clearRuleFilter': 'Clear rule filter',
  'actions.copyGitignore': 'Copy this .gitignore',
  'actions.downloadGitignore': 'Download this .gitignore',
  'actions.copyCommand': 'Copy command',
  'announcements.analyzing': 'Analysis is {progress}% complete.',
  'announcements.complete': 'Analysis complete for {count} paths.',
  'announcements.suggestionApplied':
    'Suggestion applied. Ignored paths changed from {before} to {after}.',
  'announcements.suggestionUndone': 'The last suggestion was undone.',
  'analysis.idle': 'Analysis idle',
  'analysis.running': 'Analyzing… {progress}%',
  'analysis.complete': 'Analysis complete',
  'analysis.error': 'Analysis stopped',
  'brand.home': 'WhatTheIgnore home',
  'brand.tagline': 'See exactly why Git ignores a file.',
  'header.inputActions': 'Project input actions',
  'mobile.panelTabs': 'Workbench panels',
  'mobile.rules': 'Rules',
  'mobile.files': 'Files',
  'mobile.why': 'Why',
  'notices.sampleLoaded': 'The teaching sample is ready.',
  'notices.reset': 'Inputs were reset. Your previous text was not saved.',
  'notices.folderLoaded': 'Loaded {count} project paths locally.',
  'notices.folderTruncated': 'Loaded the first {count} paths; the folder limit was reached.',
  'notices.folderLoadedWithIssues':
    'Loaded {count} safe paths locally; {issues} inputs were skipped or adjusted. Accepted paths remain available, and skipped rules can be corrected in paste mode.',
  'notices.folderTruncatedWithIssues':
    'Loaded the first {count} safe paths; the folder limit was reached and {issues} other inputs were skipped or adjusted. Accepted paths remain available.',
  'notices.gitignoreLoaded': 'The .gitignore file was loaded locally.',
  'notices.pathsWithIssues':
    'Safe inputs were applied; {count} rejected or duplicate lines remain in Paste paths for correction.',
  'notices.inputsApplied': 'Analyzing {count} pasted paths.',
  'notices.applyingSuggestion': 'Applying the suggestion and recalculating impact…',
  'notices.suggestionImpact': 'Ignored paths changed from {before} to {after}.',
  'notices.downloadStarted': 'The local download has started.',
  'notices.reportCopied': 'The report was copied.',
  'notices.gitignoreCopied': 'The updated .gitignore was copied.',
  'notices.commandCopied': 'The Git command was copied.',
  'privacy.filesNeverLeave': 'Your files never leave this browser.',
  'privacy.noFileContents': 'Only .gitignore content is read; other files are paths only.',
  'privacy.pathsOnly': 'Only relative paths and the selected .gitignore text are analyzed.',
  'errors.copy': 'Copy failed. Your text is still available; select it manually and try again.',
  'errors.export': 'Export failed. Your analysis is still available; try another export action.',
  'errors.folderLoad':
    'The folder could not be loaded. Existing input was preserved; choose it again or use paste mode.',
  'errors.gitignoreLoad':
    'The .gitignore file could not be loaded. Existing input was preserved; choose another file or paste its text.',
  'errors.workerTitle': 'Analysis could not finish',
  'paste.title': 'Paste rules and paths',
  'paste.description': 'Edit a .gitignore and enter one repository-relative path per line.',
  'paste.gitignoreLabel': '.gitignore content',
  'paste.gitignoreHelp': 'Parsing errors do not discard your text.',
  'paste.pathsLabel': 'Project paths',
  'paste.pathsHelp': 'Windows backslashes are normalized. Paths containing .. are rejected.',
  'panels.rules.kicker': 'Pattern sources',
  'panels.rules.title': 'Rules',
  'panels.rules.countLabel': '{count} parsed rules',
  'panels.rules.source': 'Ignore source',
  'panels.rules.editorLabel': 'Edit selected .gitignore',
  'panels.rules.editorHelp': 'Changes are analyzed immediately in a background worker.',
  'panels.rules.diagnostics': 'Rule diagnostics',
  'panels.rules.blankRule': '(blank line)',
  'panels.rules.matches': '{count} matches',
  'panels.rules.empty': 'No rules match this filter.',
  'panels.rules.emptyHelp': 'Clear the selected rule to show every rule.',
  'panels.files.kicker': 'Repository tree',
  'panels.files.title': 'Files',
  'panels.files.summaryLabel': 'Analysis summary',
  'panels.files.paths': 'Paths',
  'panels.files.ignored': 'Ignored',
  'panels.files.searchLabel': 'Search project paths',
  'panels.files.searchPlaceholder': 'Filter by path…',
  'panels.files.filters': 'Path status filters',
  'panels.files.filter.all': 'All',
  'panels.files.filter.ignored': 'Ignored',
  'panels.files.filter.tracked': 'Tracked',
  'panels.files.filter.warnings': 'Warnings',
  'panels.files.treeLabel': 'Analyzed project paths',
  'panels.files.hasWarnings': 'Has warnings',
  'panels.files.empty': 'No paths match this view.',
  'panels.files.emptyHelp': 'Change the search or status filter.',
  'panels.files.showMore': 'Show {count} more',
  'states.ignored': 'Ignored',
  'states.tracked': 'Tracked',
  'panels.why.kicker': 'Rule trace',
  'panels.why.title': 'Why?',
  'panels.why.empty': 'Select a file or directory',
  'panels.why.emptyHelp': 'Its decisive rule and complete match timeline will appear here.',
  'panels.why.decision': 'Final decision',
  'panels.why.source': 'Source',
  'panels.why.line': 'Line',
  'panels.why.noMatchingRule': 'No applicable rule matched this path.',
  'panels.why.timeline': 'Match timeline',
  'panels.why.matchCount': '{count} matching rules',
  'panels.why.decisive': 'Decisive',
  'panels.why.blocked': 'Blocked by parent',
  'panels.why.stateAfter': 'State after rule',
  'panels.why.noTimeline': 'There are no matching rules for this path.',
  'panels.why.warnings': 'Warnings and suggestions',
  'panels.why.commands': 'Useful Git commands',
  'panels.why.trackedNote': 'A .gitignore does not stop tracking files already in the Git index.',
  'footer.localOnly': 'Local-only',
  'footer.noUploads': 'No uploads',
  'footer.noAnalytics': 'No analytics',
  'export.description': 'Create a local report without project file contents or machine paths.',
  'export.includeProject': 'Include the project folder name',
  'export.projectName': 'Project name',
  'export.projectHelp': 'Only the final folder name is exported; absolute paths are removed.',
  'export.copyMarkdown': 'Copy Markdown',
  'export.copyMarkdownHelp': 'Copy a human-readable diagnostic summary.',
  'export.downloadMarkdown': 'Download Markdown',
  'export.downloadMarkdownHelp': 'Save the diagnostic summary as a .md file.',
  'export.copyJson': 'Copy JSON',
  'export.copyJsonHelp': 'Copy the stable report schema for tools and scripts.',
  'export.downloadJson': 'Download JSON',
  'export.downloadJsonHelp': 'Save the structured report as a .json file.',
  'explanations.path.blocked':
    'Rule {rule} matches, but an ignored parent directory prevents Git from reaching this path.',
  'explanations.path.ignoredByAncestor':
    'This path is ignored because one of its parent directories is ignored.',
  'explanations.path.noMatch':
    'This path remains tracked because no applicable ignore rule matched it.',
  'explanations.path.ignoredByRule':
    'Rule {rule} in {source}, line {line}, is the final rule that ignores this path.',
  'explanations.path.reincludedByRule':
    'Rule {rule} in {source}, line {line}, is the final rule and re-includes this path.',
  'explanations.match.blocked':
    'Negation {rule} matches the child, but an ignored parent still blocks it.',
  'explanations.match.reincluded': 'Negation {rule} changes the path to tracked.',
  'explanations.match.negationNoChange':
    'Negation {rule} matches but cannot change the final state here.',
  'explanations.match.ignored': 'Rule {rule} changes the path to ignored.',
  'explanations.match.overridden':
    'Rule {rule} matches, but a later decision leaves the path tracked.',
  'warningMessages.blockedNegation': 'A negation is blocked by an ignored parent directory.',
  'warningMessages.broadRule': 'A broad rule affects many paths.',
  'warningMessages.sensitiveUnignored': 'A potentially sensitive path is not ignored.',
  'warningMessages.sensitiveReincluded': 'A potentially sensitive path was re-included.',
  'warningReasons.blockedNegation':
    'Git does not traverse ignored directories. Re-include each parent before re-including the child.',
  'warningReasons.broadRule':
    'Broad rules are valid, but later edits can make them hide more paths than intended.',
  'warningReasons.sensitiveUnignored':
    'This check uses only the filename. Verify that credentials or private keys cannot be committed.',
  'warningReasons.sensitiveReincluded':
    'A later rule restores this sensitive-looking path. Confirm that the exception is intentional.',
} as const;

export type TranslationKey = keyof typeof english;

export const simplifiedChinese = {
  'app.name': 'WhatTheIgnore',
  'app.tagline': '看清 Git 为什么忽略这个文件。',
  'app.description': '完全在本地运行的 .gitignore 可视化调试器。',
  'actions.loadFolder': '加载文件夹',
  'actions.loadGitignore': '加载 .gitignore',
  'actions.pastePaths': '粘贴路径',
  'actions.loadSample': '加载示例',
  'actions.reset': '重置',
  'actions.apply': '应用',
  'actions.applySuggestion': '应用建议',
  'actions.undo': '撤销',
  'actions.cancel': '取消',
  'actions.close': '关闭',
  'actions.copy': '复制',
  'actions.download': '下载',
  'actions.retry': '重试',
  'actions.expandAll': '全部展开',
  'actions.collapseAll': '全部折叠',
  'actions.clearSearch': '清除搜索',
  'privacy.localOnly': '仅本地处理',
  'privacy.noUploads': '不会上传',
  'privacy.noAnalytics': '无统计追踪',
  'privacy.folderNotice': '你的文件不会离开当前浏览器。',
  'privacy.fileContents': '只读取 .gitignore；其他文件仅使用相对路径。',
  'input.sample': '示例项目',
  'input.pasteMode': '粘贴模式',
  'input.rulesLabel': '.gitignore 规则',
  'input.pathsLabel': '项目路径',
  'input.pathsHint': '每行输入一个仓库相对路径。',
  'input.dropFolder': '将项目文件夹拖到这里',
  'input.dropGitignore': '将 .gitignore 文件拖到这里',
  'input.orChoose': '或选择文件',
  'input.folderUnsupported': '当前浏览器不支持文件夹选择，请改用粘贴路径。',
  'input.pathLimit': '一次最多分析 {count} 个路径。',
  'rules.title': '规则',
  'rules.source': '来源',
  'rules.line': '第 {line} 行',
  'rules.matches': '匹配 {count} 项',
  'rules.noSelection': '选择规则以筛选受影响路径。',
  'rules.edit': '编辑规则',
  'files.title': '文件',
  'files.search': '搜索路径',
  'files.total': '共 {count} 个路径',
  'files.ignoredCount': '忽略 {count} 个',
  'files.empty': '当前筛选条件下没有路径。',
  'files.kindFile': '文件',
  'files.kindDirectory': '目录',
  'why.title': '为什么？',
  'why.finalStatus': '最终状态',
  'why.decisiveRule': '决定规则',
  'why.ruleSource': '规则来源',
  'why.timeline': '匹配时间线',
  'why.noMatch': '没有忽略规则匹配此路径。',
  'why.selectPath': '选择路径以查看全部匹配规则。',
  'why.blocked': '父目录已被忽略，因此该否定规则无法恢复子项。',
  'why.copyCheckIgnore': '复制 git check-ignore 命令',
  'why.copyRemoveCached': '复制 git rm --cached 命令',
  'status.ignored': '已忽略',
  'status.tracked': '未忽略',
  'status.active': '生效',
  'status.matched': '已匹配',
  'status.unmatched': '未匹配',
  'status.overridden': '已被覆盖',
  'status.blockedNegation': '否定规则受阻',
  'status.broadRule': '范围过宽',
  'status.comment': '注释',
  'status.blank': '空行',
  'filters.all': '全部',
  'filters.ignored': '已忽略',
  'filters.tracked': '未忽略',
  'filters.warnings': '有警告',
  'warnings.title': '规则诊断',
  'warnings.blockedNegation': '该否定规则被已忽略的父目录阻止。',
  'warnings.broadRule': '该规则范围较宽，可能影响超出预期的路径。',
  'warnings.unmatched': '该规则未匹配当前项目树。',
  'warnings.overridden': '该规则的当前匹配结果全部被后续规则覆盖。',
  'warnings.sensitiveUnignored': '一个可能敏感的路径当前未被忽略。',
  'warnings.sensitiveReincluded': '后续规则重新包含了一个可能敏感的路径。',
  'warnings.currentInputOnly': '“未匹配”仅表示没有匹配当前输入路径。',
  'progress.queued': '正在准备分析…',
  'progress.analyzing': '正在分析 {count} 个路径…',
  'progress.complete': '分析完成。',
  'progress.folder': '正在读取文件夹… {completed}/{total}',
  'errors.title': '需要处理的问题',
  'errors.workerFailed': 'Worker 意外停止，已在主线程继续分析。',
  'errors.analysisFailed': '输入仍然保留。请检查规则或路径，然后重试分析。',
  'errors.workerLargeInput':
    'Worker 当前不可用，为避免主线程冻结，没有分析这份大型输入。请减少路径数量，或在支持 Worker 的浏览器中重试。',
  'errors.invalidPath': '请只使用仓库相对路径。',
  'errors.pathTraversal': '不接受包含 .. 的路径。',
  'errors.absolutePath': '不接受也不会保存绝对路径。',
  'errors.duplicatePath': '重复路径只分析一次。',
  'errors.notGitignore': '请选择名为 .gitignore 的文件；未读取当前文件。',
  'errors.binaryGitignore': '该 .gitignore 可能是二进制文件，未进行分析。',
  'errors.invalidEncoding': '该 .gitignore 不是有效的 UTF-8。',
  'errors.gitignoreTooLarge': '该 .gitignore 过大，无法安全分析。',
  'errors.pathLimit': '文件夹超过 {count} 个路径，未继续读取剩余项目。',
  'errors.readFailed': '浏览器无法读取该文件，其他输入仍然保留。',
  'errors.exportFailed': '报告导出失败，当前分析结果仍然保留。',
  'errors.storageUnavailable': '偏好在本次会话中有效，但无法保存。',
  'export.title': '导出',
  'export.copyGitignore': '复制更新后的 .gitignore',
  'export.downloadGitignore': '下载更新后的 .gitignore',
  'export.markdown': '导出 Markdown 报告',
  'export.json': '导出 JSON 报告',
  'export.includeProjectName': '包含项目文件夹名称',
  'export.copied': '已复制到剪贴板。',
  'export.downloaded': '已准备下载。',
  'theme.dark': '深色主题',
  'theme.light': '浅色主题',
  'theme.toggle': '切换颜色主题',
  'language.label': '语言',
  'language.english': 'English',
  'language.chinese': '简体中文',
  'tabs.rules': '规则',
  'tabs.files': '文件',
  'tabs.why': '解释',
  'a11y.analysisStatus': '分析状态',
  'a11y.openMenu': '打开菜单',
  'a11y.closeDialog': '关闭对话框',
  'a11y.ruleSelected': '已选择规则',
  'a11y.pathSelected': '已选择路径',
  'footer.license': 'MIT 许可证',
  'footer.github': 'GitHub',
  'sample.name': '教学示例',
  'sample.description': '查看否定规则、被覆盖规则和已忽略父目录。',
  'accessibility.skipToWorkbench': '跳到工作区',
  'actions.exportReport': '导出报告',
  'actions.language': '选择语言',
  'actions.openGithub': '打开 GitHub 仓库',
  'actions.useDarkTheme': '使用深色主题',
  'actions.useLightTheme': '使用浅色主题',
  'actions.analyzeInputs': '分析输入',
  'actions.clearRuleFilter': '清除规则筛选',
  'actions.copyGitignore': '复制此 .gitignore',
  'actions.downloadGitignore': '下载此 .gitignore',
  'actions.copyCommand': '复制命令',
  'announcements.analyzing': '分析进度 {progress}%。',
  'announcements.complete': '已完成 {count} 个路径的分析。',
  'announcements.suggestionApplied': '建议已应用，忽略路径从 {before} 个变为 {after} 个。',
  'announcements.suggestionUndone': '已撤销上次建议。',
  'analysis.idle': '分析尚未开始',
  'analysis.running': '正在分析… {progress}%',
  'analysis.complete': '分析完成',
  'analysis.error': '分析已停止',
  'brand.home': 'WhatTheIgnore 首页',
  'brand.tagline': '看清 Git 为什么忽略这个文件。',
  'header.inputActions': '项目输入操作',
  'mobile.panelTabs': '工作区面板',
  'mobile.rules': '规则',
  'mobile.files': '文件',
  'mobile.why': '解释',
  'notices.sampleLoaded': '教学示例已就绪。',
  'notices.reset': '输入已重置，之前的文本未保存。',
  'notices.folderLoaded': '已在本地加载 {count} 个项目路径。',
  'notices.folderTruncated': '已加载前 {count} 个路径，达到文件夹上限。',
  'notices.folderLoadedWithIssues':
    '已在本地加载 {count} 个安全路径；另有 {issues} 个输入被跳过或调整。已接受的路径会保留，可在粘贴模式中修正被跳过的规则。',
  'notices.folderTruncatedWithIssues':
    '已加载前 {count} 个安全路径；已达到文件夹上限，另有 {issues} 个输入被跳过或调整。已接受的路径会保留。',
  'notices.gitignoreLoaded': '已在本地加载 .gitignore。',
  'notices.pathsWithIssues':
    '安全输入已应用；{count} 个被拒绝或重复的行仍保留在“粘贴路径”中，可重新打开后修正。',
  'notices.inputsApplied': '正在分析 {count} 个粘贴路径。',
  'notices.applyingSuggestion': '正在应用建议并重新计算影响…',
  'notices.suggestionImpact': '忽略路径从 {before} 个变为 {after} 个。',
  'notices.downloadStarted': '本地下载已开始。',
  'notices.reportCopied': '报告已复制。',
  'notices.gitignoreCopied': '更新后的 .gitignore 已复制。',
  'notices.commandCopied': 'Git 命令已复制。',
  'privacy.filesNeverLeave': '你的文件不会离开当前浏览器。',
  'privacy.noFileContents': '只读取 .gitignore 内容；其他文件仅使用路径。',
  'privacy.pathsOnly': '只分析相对路径和所选 .gitignore 文本。',
  'errors.copy': '复制失败，文本仍然可用；请手动选择文本后重试。',
  'errors.export': '导出失败，当前分析仍然可用；请尝试其他导出操作。',
  'errors.folderLoad': '无法加载文件夹，现有输入已保留；请重新选择或改用粘贴模式。',
  'errors.gitignoreLoad': '无法加载 .gitignore，现有输入已保留；请选择其他文件或粘贴其文本。',
  'errors.workerTitle': '分析未能完成',
  'paste.title': '粘贴规则和路径',
  'paste.description': '编辑 .gitignore，并每行输入一个仓库相对路径。',
  'paste.gitignoreLabel': '.gitignore 内容',
  'paste.gitignoreHelp': '解析错误不会清除你的文本。',
  'paste.pathsLabel': '项目路径',
  'paste.pathsHelp': 'Windows 反斜杠会被标准化，包含 .. 的路径会被拒绝。',
  'panels.rules.kicker': '规则来源',
  'panels.rules.title': '规则',
  'panels.rules.countLabel': '共解析 {count} 条规则',
  'panels.rules.source': '忽略规则来源',
  'panels.rules.editorLabel': '编辑所选 .gitignore',
  'panels.rules.editorHelp': '修改会立即在后台 Worker 中重新分析。',
  'panels.rules.diagnostics': '规则诊断',
  'panels.rules.blankRule': '（空行）',
  'panels.rules.matches': '匹配 {count} 项',
  'panels.rules.empty': '没有规则符合当前筛选。',
  'panels.rules.emptyHelp': '清除所选规则以显示全部规则。',
  'panels.files.kicker': '仓库树',
  'panels.files.title': '文件',
  'panels.files.summaryLabel': '分析摘要',
  'panels.files.paths': '路径',
  'panels.files.ignored': '已忽略',
  'panels.files.searchLabel': '搜索项目路径',
  'panels.files.searchPlaceholder': '按路径筛选…',
  'panels.files.filters': '路径状态筛选',
  'panels.files.filter.all': '全部',
  'panels.files.filter.ignored': '已忽略',
  'panels.files.filter.tracked': '未忽略',
  'panels.files.filter.warnings': '有警告',
  'panels.files.treeLabel': '已分析的项目路径',
  'panels.files.hasWarnings': '有警告',
  'panels.files.empty': '当前视图没有路径。',
  'panels.files.emptyHelp': '请调整搜索或状态筛选。',
  'panels.files.showMore': '再显示 {count} 项',
  'states.ignored': '已忽略',
  'states.tracked': '未忽略',
  'panels.why.kicker': '规则追踪',
  'panels.why.title': '为什么？',
  'panels.why.empty': '请选择文件或目录',
  'panels.why.emptyHelp': '这里会显示决定规则和完整匹配时间线。',
  'panels.why.decision': '最终决定',
  'panels.why.source': '来源',
  'panels.why.line': '行号',
  'panels.why.noMatchingRule': '没有适用规则匹配此路径。',
  'panels.why.timeline': '匹配时间线',
  'panels.why.matchCount': '共 {count} 条匹配规则',
  'panels.why.decisive': '决定规则',
  'panels.why.blocked': '被父目录阻止',
  'panels.why.stateAfter': '规则后的状态',
  'panels.why.noTimeline': '此路径没有匹配规则。',
  'panels.why.warnings': '警告和建议',
  'panels.why.commands': '实用 Git 命令',
  'panels.why.trackedNote': '.gitignore 不会停止跟踪已经进入 Git index 的文件。',
  'footer.localOnly': '仅本地处理',
  'footer.noUploads': '不会上传',
  'footer.noAnalytics': '无统计追踪',
  'export.description': '在本地生成不含项目文件内容和本机路径的报告。',
  'export.includeProject': '包含项目文件夹名称',
  'export.projectName': '项目名称',
  'export.projectHelp': '只导出最后一级文件夹名称，绝对路径会被移除。',
  'export.copyMarkdown': '复制 Markdown',
  'export.copyMarkdownHelp': '复制便于阅读的诊断摘要。',
  'export.downloadMarkdown': '下载 Markdown',
  'export.downloadMarkdownHelp': '将诊断摘要保存为 .md 文件。',
  'export.copyJson': '复制 JSON',
  'export.copyJsonHelp': '复制供工具和脚本使用的稳定报告结构。',
  'export.downloadJson': '下载 JSON',
  'export.downloadJsonHelp': '将结构化报告保存为 .json 文件。',
  'explanations.path.blocked': '规则 {rule} 匹配了目标，但父目录已被忽略，Git 无法继续访问该路径。',
  'explanations.path.ignoredByAncestor': '该路径被忽略，因为它的某个父目录已被忽略。',
  'explanations.path.noMatch': '没有适用的忽略规则匹配，因此该路径保持未忽略状态。',
  'explanations.path.ignoredByRule':
    '{source} 第 {line} 行的规则 {rule} 是最终决定规则，它忽略了该路径。',
  'explanations.path.reincludedByRule':
    '{source} 第 {line} 行的规则 {rule} 是最终决定规则，它重新包含了该路径。',
  'explanations.match.blocked': '否定规则 {rule} 匹配了子项，但已忽略的父目录仍然阻止它生效。',
  'explanations.match.reincluded': '否定规则 {rule} 将该路径改为未忽略。',
  'explanations.match.negationNoChange': '否定规则 {rule} 匹配了路径，但在这里无法改变最终状态。',
  'explanations.match.ignored': '规则 {rule} 将该路径改为已忽略。',
  'explanations.match.overridden': '规则 {rule} 匹配了路径，但后续决定使该路径保持未忽略。',
  'warningMessages.blockedNegation': '否定规则被已忽略的父目录阻止。',
  'warningMessages.broadRule': '一条宽泛规则影响了许多路径。',
  'warningMessages.sensitiveUnignored': '一个可能敏感的路径未被忽略。',
  'warningMessages.sensitiveReincluded': '一个可能敏感的路径被重新包含。',
  'warningReasons.blockedNegation': 'Git 不会遍历已忽略目录。请先逐级恢复父目录，再恢复子项。',
  'warningReasons.broadRule': '宽泛规则本身有效，但后续编辑可能让它隐藏超出预期的路径。',
  'warningReasons.sensitiveUnignored': '此检查仅依据文件名。请确认凭据或私钥不会被提交。',
  'warningReasons.sensitiveReincluded':
    '后续规则恢复了这个看起来敏感的路径，请确认该例外是有意设置的。',
} as const satisfies Record<TranslationKey, string>;

export type Locale = 'en' | 'zh-CN';

export const resources = {
  en: english,
  'zh-CN': simplifiedChinese,
} as const;

export type TranslationParams = Readonly<Record<string, string | number>>;

export function translate(locale: Locale, key: string, params: TranslationParams = {}): string {
  const localized = resources[locale] as Readonly<Record<string, string>>;
  const fallback = english as Readonly<Record<string, string>>;
  const template = localized[key] ?? fallback[key] ?? key;
  return template.replace(/\{([A-Za-z0-9_]+)\}/gu, (placeholder, name: string) => {
    const value = params[name];
    return value === undefined ? placeholder : String(value);
  });
}
